module.exports = __webpack_public_path__ + "static/media/all-nuggets.8216d183.svg";